import { render } from "./createComponent.vue?vue&type=template&id=00930239&scoped=true"
import script from "./createComponent.vue?vue&type=script&lang=js"
export * from "./createComponent.vue?vue&type=script&lang=js"

import "./createComponent.vue?vue&type=style&index=0&id=00930239&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00930239"]])

export default __exports__